export const paths = [
  { name: "type", value: "type" },
  { name: "id", value: "id" },
  { name: "location_id", value: "location_id" },
  { name: "address.location_id", value: "address.location_id" },
  { name: "address.lat", value: "address.lat" },
  { name: "address.lon", value: "address.lon" },
  { name: "arr_time", value: "arr_time" },
  { name: "arr_date_time", value: "arr_date_time" },
  { name: "end_time", value: "end_time" },
  { name: "end_date_time", value: "end_date_time" },
  { name: "waiting_time", value: "waiting_time" },
  { name: "distance", value: "distance" },
  { name: "driving_time", value: "driving_time" },
  { name: "preparation_time", value: "preparation_time" },
  { name: "load_before", value: "load_before" },
  { name: "load_after", value: "load_after" },
  { name: "selected", value: "selected" },
  { name: "position", value: "position" },
  { name: "ordem", value: "ordem" },
  { name: "group", value: "group" },
  { name: "customerId", value: "customerId" },
  { name: "customerName", value: "customerName" },
  { name: "hash", value: "hash" },
  { name: "fullAdress", value: "fullAdress" },
  { name: "detailLogradouro", value: "detailLogradouro" },
  { name: "detailNumber", value: "detailNumber" },
  { name: "detailNeighborhood", value: "detailNeighborhood" },
  { name: "detailCity", value: "detailCity" },
  { name: "detailUf", value: "detailUf" },
  { name: "detailCep", value: "detailCep" },
  { name: "detailComplement", value: "detailComplement" },
  { name: "city", value: "city" },
  { name: "latitude", value: "latitude" },
  { name: "longitude", value: "longitude" },
  {
    name: "deliveries[0].origin.external_code",
    value: "deliveries[0].origin.external_code",
  },
  { name: "deliveries[0].group", value: "deliveries[0].group" },
  { name: "deliveries[0].principal", value: "deliveries[0].principal" },
  { name: "deliveries[0].grouping", value: "deliveries[0].grouping" },
  {
    name: "deliveries[0].grouping_color",
    value: "deliveries[0].grouping_color",
  },
  { name: "deliveries[0].deliveryId", value: "deliveries[0].deliveryId" },
  {
    name: "deliveries[0].sequentialDelivery",
    value: "deliveries[0].sequentialDelivery",
  },
  { name: "deliveries[0].type", value: "deliveries[0].type" },
  { name: "deliveries[0].orderType", value: "deliveries[0].orderType" },
  { name: "deliveries[0].routeId", value: "deliveries[0].routeId" },
  { name: "deliveries[0].order", value: "deliveries[0].order" },
  { name: "deliveries[0].orderAt", value: "deliveries[0].orderAt" },
  { name: "deliveries[0].invoice", value: "deliveries[0].invoice" },
  {
    name: "deliveries[0].invoiceCreatedAt",
    value: "deliveries[0].invoiceCreatedAt",
  },
  { name: "deliveries[0].invoiceKey", value: "deliveries[0].invoiceKey" },
  { name: "deliveries[0].cteKey", value: "deliveries[0].cteKey" },
  {
    name: "deliveries[0].cteProtocolAuthorization",
    value: "deliveries[0].cteProtocolAuthorization",
  },
  { name: "deliveries[0].invoiceValue", value: "deliveries[0].invoiceValue" },
  { name: "deliveries[0].paymentMethod", value: "deliveries[0].paymentMethod" },
  { name: "deliveries[0].paymentDate", value: "deliveries[0].paymentDate" },
  { name: "deliveries[0].paid", value: "deliveries[0].paid" },
  { name: "deliveries[0].customer.hash", value: "deliveries[0].customer.hash" },
  {
    name: "deliveries[0].customer.customerId",
    value: "deliveries[0].customer.customerId",
  },
  {
    name: "deliveries[0].customer.cpfCnpj",
    value: "deliveries[0].customer.cpfCnpj",
  },
  {
    name: "deliveries[0].customer.customerName",
    value: "deliveries[0].customer.customerName",
  },
  {
    name: "deliveries[0].customer.fullAdress",
    value: "deliveries[0].customer.fullAdress",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailLogradouro",
    value: "deliveries[0].customer.detailedAddress.detailLogradouro",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailNumber",
    value: "deliveries[0].customer.detailedAddress.detailNumber",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailNeighborhood",
    value: "deliveries[0].customer.detailedAddress.detailNeighborhood",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailCity",
    value: "deliveries[0].customer.detailedAddress.detailCity",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailUf",
    value: "deliveries[0].customer.detailedAddress.detailUf",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailCep",
    value: "deliveries[0].customer.detailedAddress.detailCep",
  },
  {
    name: "deliveries[0].customer.detailedAddress.detailComplement",
    value: "deliveries[0].customer.detailedAddress.detailComplement",
  },
  {
    name: "deliveries[0].customer.contact",
    value: "deliveries[0].customer.contact",
  },
  {
    name: "deliveries[0].customer.whatsapp",
    value: "deliveries[0].customer.whatsapp",
  },
  {
    name: "deliveries[0].customer.phone",
    value: "deliveries[0].customer.phone",
  },
  {
    name: "deliveries[0].customer.email",
    value: "deliveries[0].customer.email",
  },
  { name: "deliveries[0].customer.city", value: "deliveries[0].customer.city" },
  {
    name: "deliveries[0].customer.latitude",
    value: "deliveries[0].customer.latitude",
  },
  {
    name: "deliveries[0].customer.longitude",
    value: "deliveries[0].customer.longitude",
  },
  {
    name: "deliveries[0].customer.consultor",
    value: "deliveries[0].customer.consultor",
  },
  {
    name: "deliveries[0].customer.matchLevel",
    value: "deliveries[0].customer.matchLevel",
  },
  {
    name: "deliveries[0].customer.color",
    value: "deliveries[0].customer.color",
  },
  {
    name: "deliveries[0].customer.colorNumber",
    value: "deliveries[0].customer.colorNumber",
  },
  {
    name: "deliveries[0].customer.toGeocode",
    value: "deliveries[0].customer.toGeocode",
  },
  {
    name: "deliveries[0].window.windowInit",
    value: "deliveries[0].window.windowInit",
  },
  {
    name: "deliveries[0].window.windowEnd",
    value: "deliveries[0].window.windowEnd",
  },
  { name: "deliveries[0].estimatedTime", value: "deliveries[0].estimatedTime" },
  { name: "deliveries[0].wait", value: "deliveries[0].wait" },
  { name: "deliveries[0].datetime", value: "deliveries[0].datetime" },
  { name: "deliveries[0].endHour", value: "deliveries[0].endHour" },
  { name: "deliveries[0].datetimeERP", value: "deliveries[0].datetimeERP" },
  { name: "deliveries[0].tolerance", value: "deliveries[0].tolerance" },
  { name: "deliveries[0].position", value: "deliveries[0].position" },
  { name: "deliveries[0].priority", value: "deliveries[0].priority" },
  { name: "deliveries[0].hours", value: "deliveries[0].hours" },
  {
    name: "deliveries[0].vehicles_allowed",
    value: "deliveries[0].vehicles_allowed",
  },
  {
    name: "deliveries[0].vehicles_disallowed",
    value: "deliveries[0].vehicles_disallowed",
  },
  { name: "deliveries[0].vehicle.code", value: "deliveries[0].vehicle.code" },
  {
    name: "deliveries[0].vehicle.external_code",
    value: "deliveries[0].vehicle.external_code",
  },
  { name: "deliveries[0].driver.name", value: "deliveries[0].driver.name" },
  { name: "deliveries[0].driver.doc", value: "deliveries[0].driver.doc" },
  {
    name: "deliveries[0].route.external_code",
    value: "deliveries[0].route.external_code",
  },
  { name: "deliveries[0].weight", value: "deliveries[0].weight" },
  { name: "deliveries[0].volume", value: "deliveries[0].volume" },
  { name: "deliveries[0].items", value: "deliveries[0].items" },
  { name: "deliveries[0].external_user", value: "deliveries[0].external_user" },
  {
    name: "deliveries[0].expected_distance",
    value: "deliveries[0].expected_distance",
  },
  { name: "deliveries[0].extra", value: "deliveries[0].extra" },
  { name: "deliveries[0].old_position", value: "deliveries[0].old_position" },
  { name: "consultor", value: "consultor" },
  { name: "totalWeight", value: "totalWeight" },
  { name: "totalVolume", value: "totalVolume" },
  { name: "priority", value: "priority" },
  { name: "allowed_vehicles", value: "allowed_vehicles" },
  { name: "disallowed_vehicles", value: "disallowed_vehicles" },
  { name: "invoicesCount", value: "invoicesCount" },
  { name: "lotesCount", value: "lotesCount" },
  { name: "totalValue", value: "totalValue" },
  { name: "uniqueKey", value: "uniqueKey" },
  { name: "matchLevel", value: "matchLevel" },
  { name: "color", value: "color" },
  { name: "colorNumber", value: "colorNumber" },
  { name: "toGeocode", value: "toGeocode" },
  { name: "serviceTime", value: "serviceTime" },
  { name: "jobWindow.first.start", value: "jobWindow.first.start" },
  { name: "jobWindow.first.end", value: "jobWindow.first.end" },
  { name: "arrivalCurrentPoint", value: "arrivalCurrentPoint" },
  { name: "outCurrentPoint", value: "outCurrentPoint" },
  { name: "timeToNextPoint", value: "timeToNextPoint" },
  { name: "waitingTime", value: "waitingTime" },
  { name: "distanceToNextPoint", value: "distanceToNextPoint" },
  { name: "arrivalNextPoint", value: "arrivalNextPoint" },
  { name: "travelledDistance", value: "travelledDistance" },
  { name: "routeColor", value: "routeColor" },
  { name: "iconIn", value: "iconIn" },
  { name: "iconOut", value: "iconOut" },
  { name: "customerIcon", value: "customerIcon" },
  { name: "arrivalCurrentPointDate", value: "arrivalCurrentPointDate" },
  { name: "arrivalCurrentPointHour", value: "arrivalCurrentPointHour" },
  { name: "outCurrentPointDate", value: "outCurrentPointDate" },
  { name: "outCurrentPointHour", value: "outCurrentPointHour" },
  { name: "timeToNextPointHs", value: "timeToNextPointHs" },
  { name: "anotherDay", value: "anotherDay" },
  { name: "vehicle", value: "vehicle" },
];

export const formats = [
  { name: "NFs", value: "getNfs" },
  { name: "NFs com data", value: "getNfsWithDate" },
  { name: "1.234,56", value: "toMoney" },
  { name: "DD/MM/YYYY HH:mm:ss", value: "toBRDatetime" },
  { name: "DD/MM/YYYY", value: "toBRDate" },
  { name: "HH:mm:ss", value: "toTime" },
];

export const structure = {
  type: "delivery",
  id: "123456789.41d7c5f3f8ba68d677cea7d405e539be",
  location_id: "123456789.41d7c5f3f8ba68d677cea7d405e539be",
  address: {
    location_id: "123456789.41d7c5f3f8ba68d677cea7d405e539be",
    lat: -9.1233211,
    lon: -35.123654,
  },
  arr_time: 1753431836,
  arr_date_time: "2025-07-25T05:23:56-03:00",
  end_time: 1753438556,
  end_date_time: "2025-07-25T07:15:56-03:00",
  waiting_time: 0,
  distance: 12796,
  driving_time: 1436,
  preparation_time: 0,
  load_before: [0, 0, 0],
  load_after: [0, 0, 0],
  selected: true,
  position: 3,
  ordem: 1,
  group: "4932",
  customerId: "123456789",
  customerName: "NOME DO CLIENTE",
  hash: "41d7c5f3f8ba68d677cea7d405e539be",
  fullAdress:
    "AV MORVAN D FIGUEIREDO, 3177, V GUILHERME, SAO PAULO - SP, 02063000, Brasil",
  detailLogradouro: "AV MORVAN D FIGUEIREDO",
  detailNumber: "3177",
  detailNeighborhood: "V GUILHERME",
  detailCity: "SAO PAULO",
  detailUf: "SP",
  detailCep: "02063000",
  detailComplement: "",
  city: "SAO PAULO",
  latitude: "-9.1233211",
  longitude: "-35.123654",
  deliveries: [
    {
      origin: { external_code: "3" },
      group: "4932",
      principal: "4932",
      grouping: "",
      grouping_color: "",
      deliveryId: "",
      sequentialDelivery: "",
      type: "",
      orderType: "",
      routeId: "",
      order: "96825623",
      orderAt: "2021-09-27 17:53:44",
      invoice: "224830",
      invoiceCreatedAt: "2021-09-27 17:53:44",
      invoiceKey: "35210905058229000362550020002248301968256234",
      cteKey: "",
      cteProtocolAuthorization: "",
      invoiceValue: "890.11",
      paymentMethod: "",
      paymentDate: "",
      paid: "",
      customer: {
        hash: "41d7c5f3f8ba68d677cea7d405e539be",
        customerId: "123456789",
        cpfCnpj: "",
        customerName: "NOME DO CLIENTE",
        fullAdress:
          "AV MORVAN D FIGUEIREDO, 3177, V GUILHERME, SAO PAULO - SP, 02063000, Brasil",
        detailedAddress: {
          detailLogradouro: "AV MORVAN D FIGUEIREDO",
          detailNumber: "3177",
          detailNeighborhood: "V GUILHERME",
          detailCity: "SAO PAULO",
          detailUf: "SP",
          detailCep: "02063000",
          detailComplement: "",
        },
        contact: "",
        whatsapp: "",
        phone: "",
        email: "",
        city: "SAO PAULO",
        latitude: "-9.1233211",
        longitude: "-35.123654",
        consultor: "",
        matchLevel: "customerId",
        color: "info",
        colorNumber: "4",
        toGeocode: false,
      },
      window: {
        windowInit: "2021-09-28 20:53:44",
        windowEnd: "2021-09-29 20:53:44",
      },
      estimatedTime: "40",
      wait: "",
      datetime: "2021-09-29 20:53:44",
      endHour: "20:53:44",
      datetimeERP: "",
      tolerance: "40",
      position: 3,
      priority: "",
      hours: "",
      vehicles_allowed: [""],
      vehicles_disallowed: [""],
      vehicle: { code: "", external_code: "" },
      driver: { name: "", doc: "" },
      route: { external_code: "1" },
      weight: "42.442",
      volume: "56",
      items: [],
      external_user: "Nome do usuário",
      expected_distance: "",
      extra: "",
      old_position: 3,
    },
  ],
  consultor: "",
  totalWeight: "42.442",
  totalVolume: "56",
  priority: 5,
  hours: {},
  allowed_vehicles: [],
  disallowed_vehicles: [],
  invoicesCount: 1,
  lotesCount: 1,
  totalValue: "890.11",
  uniqueKey: "123456789.41d7c5f3f8ba68d677cea7d405e539be",
  matchLevel: "customerId",
  color: "info",
  colorNumber: "4",
  toGeocode: false,
  serviceTime: 6720,
  jobWindow: { first: { start: "06:00", end: "11:00" } },
  arrivalCurrentPoint: "2025-07-25 08:23:56",
  outCurrentPoint: "2025-07-25 10:15:56",
  timeToNextPoint: 0,
  waitingTime: "0m",
  distanceToNextPoint: 0,
  arrivalNextPoint: "2025-07-25 10:15:56",
  travelledDistance: 12796,
  routeColor: "B71C1C",
  iconIn: "fas fa-sign-in-alt",
  iconOut: "fas fa-sign-out-alt",
  customerIcon: "fas fa-user",
  arrivalCurrentPointDate: "25/07/2025",
  arrivalCurrentPointHour: "08:23",
  outCurrentPointDate: "25/07/2025",
  outCurrentPointHour: "10:15",
  timeToNextPointHs: "0m",
  anotherDay: false,
  vehicle: 1876,
};
